import { Component, Input, ViewEncapsulation } from "@angular/core";

import { ActionState } from "@jct/ui/lib/common";
import { CardTypes } from "../card";

const ICON_MAP: Record<string, string> = {
  success: 'check_circle',
  info: 'info',
  warning: 'warning',
  error: 'error',
};

@Component({
  selector: "alert, ui-alert",
  templateUrl: "./alert.html",
  styleUrls: ["./alert.scss"],
  exportAs: "uiAlert",
  encapsulation: ViewEncapsulation.None,
  host: {
    class: "ui-alert",
    "[class.ui-alert-info]": "alertType === 'info'",
    "[class.ui-alert-error]": "alertType === 'error'",
    "[class.ui-alert-warning]": "alertType === 'warning'",
    "[class.ui-alert-success]": "alertType === 'success'",
  },
})
export class UiAlert {
  private _state: ActionState;

  @Input("type")
  alertType: CardTypes;

  get alertIcon(): string | null {
    return this.alertType ? (ICON_MAP[this.alertType] || null) : null;
  }

  get error() {
    return this._state.error;
  }
}
